// @flow

import styles from './AppInstallBanner.less';
import React from 'react';
import { Text, Section } from 'seek-style-guide/react';
import AppInstallBannerButton from 'src/components/AppInstallBannerButton/AppInstallBannerButton';

const AppInstallBanner = () => (
  <div className={styles.root}>
    <Text hero>SEEK works best in our app</Text>
    <Section>
      <AppInstallBannerButton
        analytics="app-banner-install-homepage"
        color="gray"
        className={styles.button}
        storePath="home-fixed"
        campaignSuffix="homeBanner"
      />
    </Section>
  </div>
);

export default AppInstallBanner;
